export const textCardsData = [
  {
    title: 'Образование',
    text: 'Оконченное высшее или обучение на последнем курсе ведущего вуза',
    justifySelf: { xxl: 'start' },
    maxW: { mobile: '261px', tablet: 'unset', xxl: '367px' },
  },
  {
    title: 'Языки',
    text: 'Английский уровня В2+; другие языки приветствуются',
    maxW: { mobile: '260px', tablet: 'unset', xxl: '367px' },
  },
  {
    title: 'Локация',
    text: 'Постоянное проживание на территории РФ',
    justifySelf: { xxl: 'end' },
    maxW: { mobile: '260px', tablet: 'unset', xxl: '367px' },
  },
  {
    title: 'Коммуникация',
    text: 'Умение работать с возражениями и проактивно управлять процессами',
    maxW: { mobile: '284px', tablet: 'unset' },
  },
  {
    title: 'Знания аналитики и ИТ',
    text: 'Математика, статистика, аналитика, базы данных и понимание процессов в ИТ-сфере',
    gridColumn: { tablet: '2 / 4', xxl: '3 / 4' },
    maxW: { mobile: '343px', tablet: 'unset' },
  },
];
